import { ConfigHelper } from './../../app/helpers/configHelper';
import { AlertProvider } from './../alert/alert';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpResultModel } from '../../app/models/HttpResultModel';
import { SpinnerProvider } from '../spinner/spinner';
import { NetworkProvider } from '../network/network';
import { timeout } from 'rxjs/operators';
import { App} from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Env } from '../../environments/environment';



@Injectable()
export class HttpProvider {

  idUsuario: string = '';
  idLoja: string = '';
  dispositivo: string = '';
  versao : string = '';
  token : string = '';
  
  constructor(
    private http: HttpClient,
    private spinnerSrv: SpinnerProvider,
    private alertSrv: AlertProvider,
    private storage: Storage,
    private app : App,
    private networkSrv: NetworkProvider
  ) {

  }

  createHeader(header?: HttpHeaders): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }

    // header = header.set('token', ConfigHelper.Token);
    return header;  
  }

  createHeaderAntigo(header?: HttpHeaders): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }
    header = header.set('Token', ConfigHelper.Token);  
    return header;
  }
  
  createHeaderNotificacoes(header?: HttpHeaders): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }
    header = header.set('Token', ConfigHelper.TokenNotivicacoes);

    return header;
  }

  createHeaderDms(header?: HttpHeaders): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }
    header = header.set('Token', ConfigHelper.TokenDms);

    return header;
  }

  getApi(url: string, loading: number = 1, mensagem: string = "Carregando os dados...", tempoSpinner: number = null, timeOut: number = 15000): Promise<HttpResultModel> {

    let header = this.createHeader();

    let _url = Env.UrlApi + url;

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem, tempoSpinner);
        }

        //Monta o header com as informações para a nova API
        this.storage.get('token').then((token) => {
          this.token = 'Bearer '+ token;

          this.storage.get('idUsuario').then((idUsuario) => {
            this.idUsuario = idUsuario;
  
            this.storage.get('idLoja').then((idLoja) => {
              this.idLoja = idLoja;
      
              this.storage.get('dispositivo').then((dispositivo) => {
                this.dispositivo = dispositivo;
  
                this.storage.get('versao').then((versao) => {
                  this.versao = ConfigHelper.Version;
    
                  if(this.versao != '' && this.versao != null){
                    header = header.set('versao', this.versao);
                  }
    
                  if(this.idUsuario != '' && this.idUsuario != null){
                    header = header.set('idUsuario', this.idUsuario);
                  }
                  if(this.idLoja != '' && this.idLoja != null){
                    header = header.set('idLoja', this.idLoja);
                  }
                  if(this.dispositivo != '' && this.dispositivo != null){
                    header = header.set('dispositivo', this.dispositivo);
                  }
                  if(this.token != '' && this.token != null){
                    header = header.set('Authorization', this.token);
                  }
    
                  this.http.get(_url, { headers: header })
                    .pipe(
                      timeout(timeOut)
                    )
                    .subscribe(_res => {
                      if (loading == 1) {
                        this.spinnerSrv.Hide();
                      }
                      if(typeof _res != undefined && _res['logout']){
                        this.app.getRootNav().setRoot('LoginPage');
                        this.alertSrv.alertConfirm('Informação', _res['mensagem'], x => {
                          document.location.reload();
                        });
                      }else{
                        resolve({ success: true, data: _res, err: undefined });
                      }
          
                    }, err => {
                      if (loading == 1) {
                        this.spinnerSrv.Hide();
                      }
          
                      if (err.status == 403) {
                        let msg = '';
                        err.error.forEach(_err => {
                          msg += `<li>${_err.retorno}</li>`;
                        });
                        this.alertSrv.alert('Informação', msg);
                      } 
                      else if (err.status == 400) {
                        let msg = '';
                        err.error.forEach(_err => {
                          msg += `<li>${_err.retorno}</li>`;
                        });
                        this.alertSrv.alert('Informação', msg);
                      } 
                      else if (err.status == 401) {
                        this.app.getRootNav().setRoot('LoginPage');
                        this.alertSrv.alertConfirm('Informação', "Acesso expirado, faça o login novamente.", x => {
                          // document.location.reload();
                        });
                      } 
                      else if (err.status == 200) {
                        let msg = err.error.text;
          
                        this.alertSrv.alert('Problema ao Salvar', msg);
                      } else {
                        this.alertSrv.alert('Sem Conexão com Internet', 'Você está Offline, e infelizmente os dados não podem ser carregados do servidor!');
                        resolve({ success: false, data: undefined, err: undefined });
                      }
                      resolve({ success: false, data: undefined, err: err });
                    });
                });
              });
            });
          });

        });

      }
      else {
        this.alertSrv.alert('Sem Conexão com Internet', 'Você está Offline, e infelizmente os dados não podem ser carregados do servidor!');
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }

  getLocal(url: string): Promise<HttpResultModel> {

    let header = this.createHeader();
    let _url = url;
    //console.log(_url);

    return new Promise((resolve) => {

      this.http.get(_url, { headers: header })
        .subscribe(_res => {
          //let json = JSON.parse(_res.data);
          resolve({ success: true, data: _res, err: undefined });
        }, err => {
          if (err.status != 404) {
            //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
          }

          //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
          resolve({ success: false, data: undefined, err: err });
        });

    });
  }

  getDms(url: string, loading: number = 1, mensagem: string = "Carregando os dados..."): Promise<HttpResultModel> {

    let header = this.createHeaderDms();
    let _url = ConfigHelper.UrlDms + url;
    //console.log(_url);

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.get(_url, { headers: header })
          .pipe(
            timeout(15000)
          )
          .subscribe(_res => {

            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {

            if (loading == 1) {
              this.alertSrv.alert('Sem conexão com o Servidor', 'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!');

              this.spinnerSrv.Hide();
            }
            //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        this.alertSrv.alert('Sem Conexão com Internet', 'Você está Offline, e infelizmente os dados não podem ser carregados do servidor!');
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }

  postApi(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 80000): Promise<HttpResultModel> {

    let header = this.createHeader();
    let _url = Env.UrlApi + url;
    // console.log('model => ', model)
    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {
        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        //Monta o header com as informações para a nova API
        this.storage.get('token').then((token) => {
          this.token = 'Bearer '+ token;

          this.storage.get('idUsuario').then((idUsuario) => {
            this.idUsuario = idUsuario;
  
            this.storage.get('idLoja').then((idLoja) => {
              this.idLoja = idLoja;
      
              this.storage.get('dispositivo').then((dispositivo) => {
                this.dispositivo = dispositivo;
  
                this.storage.get('versao').then((versao) => {
                  this.versao = ConfigHelper.Version;
    
                  if(this.versao != '' && this.versao != null){
                    header = header.set('versao', this.versao);
                  }
    
                  if(this.idUsuario != '' && this.idUsuario != null){
                    header = header.set('idUsuario', this.idUsuario);
                  }
                  if(this.idLoja != '' && this.idLoja != null){
                    header = header.set('idLoja', this.idLoja);
                  }
                  if(this.dispositivo != '' && this.dispositivo != null){
                    header = header.set('dispositivo', this.dispositivo);
                  }
                  if(this.token != '' && this.token != null){
                    header = header.set('Authorization', this.token);
                  }
    
                  this.http.post(_url, model, { headers: header })
                    .pipe(
                      timeout(timeOut)
                    )
                    .subscribe(_res => {
                      if (loading == 1) {
                        this.spinnerSrv.Hide();
                      }
                      if(typeof _res != undefined && _res['logout']){
                        this.app.getRootNav().setRoot('LoginPage');
                        this.alertSrv.alertConfirm('Informação', _res['mensagem'], x => {
                          document.location.reload();
                        });
                      }else{
                        resolve({ success: true, data: _res, err: undefined });
                      }
          
                    }, err => {
                      if (loading == 1) {
                        this.spinnerSrv.Hide();
                      }
          
                      if (err.status == 403) {
                        let msg = '';
                        err.error.forEach(_err => {
                          msg += `<li>${_err.retorno}</li>`;
                        });
                        this.alertSrv.alert('Informação', msg);
                      } 
                      else if (err.status == 400) {
                        let msg = '';
                        err.error.forEach(_err => {
                          msg += `<li>${_err.retorno}</li>`;
                        });
          
                        this.alertSrv.alert('Informação', msg);
                      } 
                      else if (err.status == 401) {
                        this.app.getRootNav().setRoot('LoginPage');
                        this.alertSrv.alertConfirm('Informação', "Acesso expirado, faça o login novamente.", x => {
                          // document.location.reload();
                        });
                      } 
                      else if (err.status == 200) {
                        let msg = err.error.text;
          
                        this.alertSrv.alert('Problema ao Salvar', msg);
                      } else {
                        if (verconexao == 1 && loading == 1) {
                          this.alertSrv.alert('Sem conexão com o Servidor', 'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!');
                        }
                      }
                      resolve({ success: false, data: undefined, err: err });
                    });
                });
              });
            });
          });

        });

      } else {
        if (verconexao == 1) {
          this.alertSrv.alert('Sem Conexão com Internet', 'Você está Offline, e infelizmente os dados não podem ser carregados do servidor!');
        }
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }

  postNotificacoes(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 80000): Promise<HttpResultModel> {
    let header = this.createHeaderNotificacoes();
    let _url = ConfigHelper.UrlNotificacoes + url;
    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {
        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }
        this.http.post(_url, model, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            if (err.status == 403) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });
              this.alertSrv.alert('Informação', msg);
            } else if (err.status == 400) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });

              this.alertSrv.alert('Informação', msg);
            } else if (err.status == 200) {
              let msg = err.error.text;

              this.alertSrv.alert('Problema ao Salvar', msg);
            } else {
              if (verconexao == 1 && loading == 1) {
                this.alertSrv.alert('Sem conexão com o Servidor', 'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!');
              }
            }
            resolve({ success: false, data: undefined, err: err });
          });
      } else {
        if (verconexao == 1) {
          this.alertSrv.alert('Sem Conexão com Internet', 'Você está Offline, e infelizmente os dados não podem ser carregados do servidor!');
        }
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }

  postDms(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 190000): Promise<HttpResultModel> {

    let header = this.createHeaderDms();
    let _url = ConfigHelper.UrlDms + url;

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            if (verconexao == 1 && loading == 1) {
              this.alertSrv.alert('Sem conexão com o Servidor', 'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!');
            }
            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.alert('Sem Conexão com Internet', 'Você está Offline, e infelizmente os dados não podem ser carregados do servidor!');
        }
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }
  
  createHeaderChecklist(header?: HttpHeaders): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }
    header = header.set('Token', ConfigHelper.TokenChecklist);

    return header;
  }

  getChecklist(url: string, loading: number = 1, mensagem: string = "Carregando os dados...", tempoSpinner: number = null, timeOut: number = 15000): Promise < HttpResultModel > {

    let header = this.createHeader();
    let _url = Env.UrlApi + 'api/v1/' + url;

    return new Promise((resolve) => {
        if (this.networkSrv.IsOnline) {

            if (loading == 1) {
                this.spinnerSrv.Show(mensagem, tempoSpinner);
            }

            this.http.get(_url, { headers: header }).pipe(
                timeout(timeOut)
            )
                .subscribe(_res => {
                    if (loading == 1) {
                        this.spinnerSrv.Hide();
                    }
                    //let json = JSON.parse(_res.data);
                    resolve({ success: true, data: _res, err: undefined });
                }, err => {

                    console.log('deu erro');
                    if (err.status != 404) {
                        //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
                    }

                    if (loading == 1) {
                        this.spinnerSrv.Hide();
                    }

                    if (err == "TimeoutError: Timeout has occurred") {
                        if (loading == 1) {
                            this.alertSrv.alert('Sem conexão com o Servidor', 'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!');
                        }
                    }

                    //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
                    resolve({ success: false, data: undefined, err: err });
                });
        }
        else {
            this.alertSrv.alert('Sem Conexão com Internet', 'Você está Offline, e infelizmente os dados não podem ser carregados do servidor!');
            resolve({ success: false, data: undefined, err: undefined });
        }
    });
}

postChecklist(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 90000): Promise < HttpResultModel > {

    let header = this.createHeader();

    let _url = Env.UrlApi + 'api/v1/' + url
    console.log('url savando', _url);
    return new Promise((resolve) => {
        if (this.networkSrv.IsOnline) {
            if (loading == 1) {
                this.spinnerSrv.Show(mensagem);
            }
            this.http.post(_url, model, { headers: header })
                .pipe(
                    timeout(timeOut)
                )
                .subscribe(_res => {
                    if (loading == 1) {
                        this.spinnerSrv.Hide();
                    }
                    //let json = JSON.parse(_res.data);
                    resolve({ success: true, data: _res, err: undefined });
                }, err => {
                    if (loading == 1) {
                        this.spinnerSrv.Hide();
                    }

                    if (err.status == 403) {
                        let msg = '';
                        err.error.forEach(_err => {
                            msg += `<li>${_err.retorno}</li>`;
                        });
                        this.alertSrv.alert('Informação', msg);
                    }
                    else if (err.status == 400) {
                        let msg = '';
                        err.error.forEach(_err => {
                            msg += `<li>${_err.retorno}</li>`;
                        });

                        this.alertSrv.alert('Informação', msg);
                    }
                    else if (err.status == 200) {
                        let msg = err.error.text;
                        this.alertSrv.alert('Problema ao Salvar', msg);
                    }
                    else {

                        if (verconexao == 1 && loading == 1) {
                            this.alertSrv.alert('Sem conexão com o Servidor', 'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!');
                        }

                        //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
                    }

                    resolve({ success: false, data: undefined, err: err });
                });
        }
        else {
            if (verconexao == 1) {
                this.alertSrv.alert('Sem Conexão com Internet', 'Você está Offline, e infelizmente os dados não podem ser carregados do servidor!');
            }

            resolve({ success: false, data: undefined, err: undefined });

        }
    });
}


putChecklist(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 90000): Promise < HttpResultModel > {

    let header = this.createHeaderChecklist();
    let _url = Env.UrlApi + 'api/' + url;

    return new Promise((resolve) => {
        if (this.networkSrv.IsOnline) {

            if (loading == 1) {
                this.spinnerSrv.Show(mensagem);
            }

            this.http.put(_url, model, { headers: header })
                .pipe(
                    timeout(timeOut)
                )
                .subscribe(_res => {
                    console.log("_res", _res);
                    if (loading == 1) {
                        this.spinnerSrv.Hide();
                    }
                    //let json = JSON.parse(_res.data);
                    resolve({ success: true, data: _res, err: undefined });
                }, err => {
                    if (loading == 1) {
                        this.spinnerSrv.Hide();
                    }

                    console.log('Erro[ZCVXC187]', err);

                    if (err.status == 403) {
                        let msg = '';
                        err.error.forEach(_err => {
                            msg += `<li>${_err.retorno}</li>`;
                        });
                        this.alertSrv.alert('Informação', msg);
                    }
                    else if (err.status == 400) {
                        let msg = '';
                        err.error.forEach(_err => {
                            msg += `<li>${_err.retorno}</li>`;
                        });

                        this.alertSrv.alert('Informação', msg);
                    }
                    else if (err.status == 200) {
                        let msg = err.error.text;

                        this.alertSrv.alert('Problema na Atualização', msg);
                    }
                    else {

                        if (verconexao == 1 && loading == 1) {
                            this.alertSrv.alert('Sem conexão com o Servidor', 'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!');
                        }

                        //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
                    }

                    resolve({ success: false, data: undefined, err: err });
                });
        }
        else {
            if (verconexao == 1) {
                this.alertSrv.alert('Sem Conexão com Internet', 'Você está Offline, e infelizmente os dados não podem ser carregados do servidor!');
            }

            resolve({ success: false, data: undefined, err: undefined });

        }
    });
}

}


// WEBPACK FOOTER //
// ./src/providers/http/http.ts